import { Alert, Platform } from "react-native";

export async function confirmAndRun(message: string, run: () => Promise<void>): Promise<void> {
  if (Platform.OS === "web") {
    if (typeof window !== "undefined" && window.confirm(message)) {
      await run();
    }
    return;
  }

  Alert.alert("Confirm", message, [
    { text: "Cancel", style: "cancel" },
    { text: "Confirm", style: "destructive", onPress: () => void run() },
  ]);
}
